import React, { useState } from "react";
import { Box, ButtonGroup, FormControl, Text } from "@primer/react";
import { useCommonContext } from "../../contexts/common";
import { NotifyHelper } from "../../helpers/toast";
import { useCommonSelectedHook } from "../../hooks/useCommonSelectedHook";
import Modal from "../../components/ui/modal";
import Button from "../../components/ui/button";
import { phuHuynhApi } from "../../api/phuHuynhApi";
import ComboBoxNguoiPhuTrach from "../../components/combobox-phuhuynh-nguoiphutrach";

interface GanNguoiPhuTrachDetailModalProps {
  selectedIds: number[];
  onClose: () => void;
  onSuccess: () => void;
}

const GanNguoiPhuTrachDetailModal: React.FC<
  GanNguoiPhuTrachDetailModalProps
> = ({ selectedIds, onClose, onSuccess }) => {
  const [isSaving, setIsSaving] = useState(false);
  const [selectedNguoiPhuTrachId, setSelectedNguoiPhuTrachId] =
    useState<number>(0);

  const { translate } = useCommonContext();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!selectedNguoiPhuTrachId) {
      NotifyHelper.Error(translate("Vui lòng chọn người phụ trách"));
      return;
    }

    setIsSaving(true);
    try {
      const res = await phuHuynhApi.updateNguoiPhuTrach({
        phu_huynh_ids: selectedIds,
        nguoi_phu_trach_id: selectedNguoiPhuTrachId,
      });

      if (res.is_success) {
        NotifyHelper.Success(translate("Success.Update"));
        onSuccess();
        onClose();
      } else {
        NotifyHelper.Error(
          res.data?.message || translate("Error.UpdateFailed")
        );
      }
    } catch (error) {
      NotifyHelper.Error(translate("Error.Generic"));
    }
    setIsSaving(false);
  };

  return (
    <Modal
      isOpen
      onClose={onClose}
      width="large"
      title={`${translate("Gán người phụ trách")}`}
    >
      <form onSubmit={handleSubmit}>
        <Box sx={{ mb: 3 }}>
          <FormControl>
            <Text sx={{ mb: 2, color: 'text.secondary' }}>
              {translate("Bạn đang chọn")}: {selectedIds.length} {translate("người")}
            </Text>
            <ComboBoxNguoiPhuTrach
              value={selectedNguoiPhuTrachId}
              onValueChanged={(id: number) => {
                setSelectedNguoiPhuTrachId(id ?? 0);
              }}
              isShowClearBtn
            />
          </FormControl>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <ButtonGroup>
            <Button onClick={onClose}>{translate("Base.Label.Cancel")}</Button>
            <Button
              variant="primary"
              type="submit"
              disabled={isSaving || !selectedNguoiPhuTrachId}
            >
              {translate("Base.Label.Update")}
            </Button>
          </ButtonGroup>
        </Box>
      </form>
    </Modal>
  );
};

export default GanNguoiPhuTrachDetailModal;